import { render, staticRenderFns } from "./ShiftPeriodEdit.vue?vue&type=template&id=31085744&"
import script from "./ShiftPeriodEdit.vue?vue&type=script&lang=js&"
export * from "./ShiftPeriodEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports